import React from 'react';
import { format } from 'libphonenumber-js';

import StorePresenter from '../../../../../../../presenters/StorePresenter';
import DatePresenter from '../../../../../../../presenters/DatePresenter';
import Group from '../../../../../../../components/Group';
import Column from '../../../../../../../components/Column';
import Row from '../../../../../../../components/Row';
import Value from '../../../../../../../components/Value';
import Image from '../../../../../../../components/Image';
import { Label, ShareableLink } from '../../../../../../../components';

const StoreInfo = (props) => {
  const { brand } = props;

  const normalServiceHoursText = () => {
    const openingHour = StorePresenter.normalOpeningHour(brand);
    const closingHour = StorePresenter.normalClosingHour(brand);
    return `${DatePresenter.humanizeHour(
      openingHour
    )} - ${DatePresenter.humanizeHour(closingHour)}`;
  };

  const sundayServiceHoursText = () => {
    const openingHour = StorePresenter.sundayOpeningHour(brand);
    const closingHour = StorePresenter.sundayClosingHour(brand);
    return `${DatePresenter.humanizeHour(
      openingHour
    )} - ${DatePresenter.humanizeHour(closingHour)}`;
  };

  return (
    <Group title="General">
      <Row>
        <Column>
          <Value attr="name" title="Name">
            {StorePresenter.name(brand)}
          </Value>
          <Value attr="defaultCashbackRate" title="Default Cashback Rate">
            {StorePresenter.defaultCashbackRate(brand)}
          </Value>

          <Value attr="birthdayCashbackRate" title="Birthday Cashback Rate">
            {StorePresenter.birthdayCashbackRateReadable(brand)}
          </Value>

          <div className="unique-in-state-field checkbox">
            <input
              type="checkbox"
              id="uniqueInState"
              checked={StorePresenter.uniqueInState(brand)}
              disabled
            />
            <Label attr="uniqueInState" text="Unique in State" />
          </div>

          <div className="fast-cash-enabled checkbox">
            <input
              type="checkbox"
              id="fastCashEnabled"
              checked={StorePresenter.fastCashEnabled(brand)}
              disabled
            />
            <Label attr="fastCashEnabled" text="FastCash enabled" />
          </div>

          <Value attr="phoneNumber" title="Phone Number">
            {format(StorePresenter.phoneNumber(brand), 'US', 'National')}
          </Value>

          <Value attr="customer-service-email" title="Customer Service E-mail">
            {StorePresenter.customerServiceEmail(brand)}
          </Value>
        </Column>
        <Column>
          <Value attr="email" title="E-mail">
            {StorePresenter.email(brand)}
          </Value>

          <ShareableLink
            name="shareableLink"
            title="Shareable Link"
            url={StorePresenter.shareableUrl(brand)}
          />
          <ShareableLink
            name="appUrl"
            title="App Link"
            url={StorePresenter.appUrl(brand)}
          />
          <div className="is-featured-field checkbox">
            <input
              type="checkbox"
              id="isFeatured"
              checked={StorePresenter.isFeatured(brand)}
              disabled
            />
            <Label attr="isFeatured" text="Is Featured" />
          </div>
        </Column>
        <Column>
          <Value attr="store_number" title="Store Number">
            {StorePresenter.storeNumber(brand)}
          </Value>

          <Value attr="billing_address" title="Billing Address">
            {StorePresenter.billingAddress(brand)}
          </Value>
        </Column>
      </Row>
      <Row>
        <Value
          className="normal-hours"
          attr="normal-hours"
          title="Monday - Saturday Hours"
        >
          {StorePresenter.normalServiceHoursText(brand)}
        </Value>
        <Value
          className="sunday-hours"
          attr="sunday-hours"
          title="Sunday Hours"
        >
          {StorePresenter.sundayServiceHoursText(brand)}
        </Value>
      </Row>

      <Row>
        <Image
          attr="logo"
          title="Logo"
          src={StorePresenter.logoUrlReadable(brand)}
        />

        <div className="input brand-image-upload">
          <div className="image-upload-header">
            <Label attr="image" text="Image" />
          </div>
          <div className="brand-image-upload-dropzone">
            <div className="image-preview-wrapper">
              <div
                className="image-preview"
                style={{
                  backgroundImage: `url("${StorePresenter.imageUrlReadable(
                    brand
                  )}")`,
                }}
              />
            </div>
          </div>
        </div>
      </Row>

      <Row>
        <Image
          attr="locationMap"
          title="Location Map"
          src={StorePresenter.locationMapUrlReadable(brand)}
        />
      </Row>

      <Value className="categories" attr="categories" title="Categories">
        {brand.categories.map((c) => (
          <li key={c.id}>{c.name}</li>
        ))}
      </Value>
    </Group>
  );
};

export default StoreInfo;

StoreInfo.propTypes = {
  brand: StorePresenter.shape().isRequired,
};
